import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=9b955fd6&scoped=true&"
import script from "./manager.vue?vue&type=script&lang=js&"
export * from "./manager.vue?vue&type=script&lang=js&"
import style0 from "./manager.vue?vue&type=style&index=0&id=9b955fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b955fd6",
  null
  
)

export default component.exports